export const trunc = (x: number, posiciones: number = 0) => {
  var s = x.toString();
  /* var l = s.length */
  var decimalLength = s.indexOf(".") + 1;
  var numStr = s.substr(0, decimalLength + posiciones);
  return Number(numStr);
};
